import React, { useEffect } from 'react'; 
import Sidebar from './Sidebar'; 
import Info from './Info'; 
import { Link, useParams } from 'react-router-dom';
import styles from './../../Assets/CSS/Style.module.css';
import successImg from './../../Assets/Images/success.png';
import failedImg from './../../Assets/Images/failed.png'; 
   
function PaymentStatus() {  
    const { status } = useParams();  
    useEffect(() => {
        document.title = 'Infomart | Agent Payment Status'; 
    }, []);  
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    <div className="text-center mt-5">
                        <div className={styles.contactUsPageContainer}>  
                            {status == 'success' ? 
                                <>  
                                    <img src={successImg} height={90} width={90} />
                                    <p className="mt-4" style={{ fontSize: 20, fontWeight: "bold", color: "#125fdc" }}>Your payment was successful.</p>
                                </> 
                            :
                                <>
                                    <img src={failedImg} height={90} width={90} />
                                    <p className="mt-4" style={{ fontSize: 20, fontWeight: "bold", color: "#125fdc" }}>Payment failed. Please try again.</p>
                                </>  
                            }   
                            <Link to="/agent/profile" className="btn btn-success fw-bold mt-4">Back to Profile</Link>
                        </div>          
                    </div>      
                </div> 
            </div> 
        </div>
    );
}

export default PaymentStatus;               